import { TabContext, TabList, TabPanel } from '@mui/lab';
import {
  Avatar,
  Box,
  Divider,
  Grid,
  Paper,
  Stack,
  Tab,
  Typography,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { LoadingWidget } from '../../../../widgets';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';

const PanelJuegosView = () => {
  // const dispatch = Redux.useDispatch();

  const juegosStore = Redux.useSelector((state) => state.juegos);

  const activo = juegosStore.activo;

  const [tab, setValue] = React.useState('1');

  const handleTabs = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={juegosStore.loadingAll}
          text={'Cargando datos...'}
        />
      </Grid>
      <Grid item md={4}>
        <Stack direction="column" spacing={1}>
          <Paper elevation={4}>
            <Grid container spacing={0}>
              <Grid item xs={12} md={12} align="center">
                <Avatar
                  alt={activo.imagen?.pnombre}
                  sx={{ width: 150, height: 150, my: 2 }}
                  src={getFilesArchivos(activo.imagen?.avatar)}
                />
              </Grid>
              <Grid item xs={12} md={12} align="center">
                <Typography variant="h6">{activo.nombre}</Typography>
              </Grid>
              <Grid item xs={12} md={12} align="center">
                <Divider textAlign="left">Detalles</Divider>
              </Grid>
              <Grid item xs={12} md={12} sx={{ p: 2 }}>
                <Grid container spacing={0}>
                  <Grid item xs={12} md={12}>
                    <Typography variant="body">
                      <strong>Deporte: </strong>
                      {activo.deporte.nombre}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Typography variant="body">
                      <strong>Cantidad de equipos: </strong>
                      {activo.equipos}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Typography variant="body">
                      <strong>Fecha de inicio: </strong>
                      {activo.fecha}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Stack>
      </Grid>
      <Grid item md={8}>
        <Paper elevation={4}>
          <TabContext value={tab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabs} aria-label="lab API tabs example">
                <Tab label="Equipos" value="1" />
                <Tab label="Juegos" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1" sx={{ p: 0 }}></TabPanel>
            <TabPanel value="2" sx={{ p: 0 }}></TabPanel>
          </TabContext>
        </Paper>
      </Grid>

      {/* <ModalComponent
        id="modalFormFamiliares"
        title={`${
          activo
            ? `Editar ${activo.nombre}-${activo.nivelAcademico.nivelAcademico.nombre}`
            : "Nueva sección"
        }`}
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormFamiliares
          activo={activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        /> 
      </ModalComponent> */}
    </Grid>
  );
};

export default PanelJuegosView;
